import { Module, State } from 'vuex-simple';
import { BaseModule, createHandler } from '@/HostApp/store/ApsModules/BaseModule';
import { AppModule } from '@/HostApp/store/ApsModules/AppModule';
import { ContextModule } from '@/HostApp/store/ApsModules/ContextModule';
import IframeApscModule from '@/HostApp/store/ApsModules/IframeApscModule';

/**
 * This module will be attached to each legacy iframe aps variable, to get an opportunity manage iframe state
 **/

export default class IframeApsModule extends BaseModule {
	constructor() {
		super();
		/**
		 * By default, @Module has only getter, to redefine this behavior use 'createHandler' to call
		 * 'updateState' method in a nested module to extend standard handler with set: (value)=> { this.updateState(value) }.
		 * Parent class BaseModule has a method 'updateState' to parse incoming values if something try to replace a module property
		 **/

		Object.defineProperty(this, 'app', createHandler(this.app));
		Object.defineProperty(this, 'apsc', createHandler(this.apsc));
		Object.defineProperty(this, 'context', createHandler(this.context));
	}

	@Module()
	public hostServices = window.aps.hostServices;

	@Module()
	public context: ContextModule = new ContextModule();

	@Module()
	public app: AppModule = new AppModule();

	@Module()
	public apsc: IframeApscModule = new IframeApscModule();

	@State()
	public get navigation(): { isVueWorkspace: boolean } {
		return {
			isVueWorkspace: window.aps.navigation.isVueWorkspace
		};
	}
}
